import React from "react";
import { Box, Flex, Link, Text } from "@chakra-ui/react";
import { generatePageUrl } from "@core/utils";

const links = [
  {
    link: 'https://mamaginekolog.pl/regulamin-bloga/',
    name: "Regulamin"
  },
  {
    link: 'https://mamaginekolog.pl/polityka-prywatnosci-bloga',
    name: "Polityka prywatności"
  },
  {
    link: 'https://mamaginekolog.pl/regulamin-konkursu',
    name: "Regulamin konkursu"
  },
  {
    link: 'https://mamaginekolog.pl/pliki-do-druku',
    name: "Pliki do pobrania"
  },
  {
    link: 'https://mamaginekolog.pl/kontakt',
    name: "Kontakt"
  },
]

const FooterPolicy = () => (
  <>
    <Flex mb="21px" gridGap="30px" fontSize="12px" color="#222C63" alignItems="center" fontWeight="600" flexDirection={{base: 'column', md: 'row'}}>
      {
        typeof window !== 'undefined' &&
        links.map((item) => (
          <Link key={item.link} href={`${item.link}`}>{item.name}</Link>
          )
        )
      }

    </Flex>
    <Box mt={{base: '16px', md: 0}} fontSize="10px" color="#8B9CAE">
      ul. Algierska 19W, 03-977 Warszawa. KRS 0001008022, NIP 5252678750, BDO 000108449<br />&copy;
      © {new Date().getFullYear()} Roger Publishing sp. z o.o.
    </Box>
  </>

);

export default FooterPolicy;
